/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobQueueRequest {
    getFixupPrototypeFunction() { return BackgroundJobQueueRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobQueueRequest>): BackgroundJobQueueRequest {
        let obj = Object.assign(new BackgroundJobQueueRequest(), model);
        BackgroundJobQueueRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobQueueRequest>): BackgroundJobQueueRequest {
        if (!model) return null;
        return BackgroundJobQueueRequest.newInstance(<BackgroundJobQueueRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobQueueRequest) {
        if (!obj) return;

        models.BackgroundJobQueueRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobQueueRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobQueueRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.priority === undefined) {
            this.priority = 0;
        }
        if (this.auto_retries === undefined) {
            this.auto_retries = 0;
        }
        if (this.auto_retry_delay === undefined) {
            this.auto_retry_delay = 0;
        }
        if (typeof this.next_activation === "string") {
            this.next_activation = new Date(<string><any>this.next_activation);
        }
        if (this.payload) {
            models.BackgroundJobPayloadBase.fixupPrototype(this.payload);
        }
        if (this.waiting_on) {
            for (let val of this.waiting_on) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    /**
     * Target Executor for the job
     */
    executor: models.BackgroundJobExecutor;

    /**
     * Data associated with the Background Job
     */
    payload: models.BackgroundJobPayloadBase;

    /**
     * Priority of the Background Job
     */
    priority: number;

    /**
     * When the Background Job will execute
     */
    next_activation: Date;

    /**
     * Ensure all the federation updates are sent
     */
    synchronize_federation: boolean;

    /**
     * Only queue if no other job is already queued. Queue if other job is already running
     */
    check_for_queued_job: boolean;

    /**
     * Only queue if no matching job is found
     */
    check_for_running_job: boolean;

    /**
     * Queue to run after any matching job
     */
    queue_after_running_job: boolean;

    /**
     * Number of auto retries left for this Background Job
     */
    auto_retries: number;

    /**
     * Number of seconds to wait before a retry for this Background Job
     */
    auto_retry_delay: number;

    /**
     * Background Jobs this job is dependent for
     */
    waiting_on: Array<models.RecordIdentity>;

}
